// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.updatesetup_updateSetupContainer__oszGJ {
  display: flex;
  flex:  5 1;
  flex-direction: column;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  background-color: var(--hsrcBackgroundLight);
  border-radius: 1rem;
  padding: 2rem;

}

.updatesetup_featuredItem__QyaVl {
  flex: 1 1;
  margin: 0px 20px;
  padding: 30px;
  border-radius: 10px;
  cursor:default;

}
.updatesetup_featuredDropDown__m64Mu {
  flex: 1 1;
  margin: 0px 20px;
  padding: 30px;
  border-radius: 10px;
  cursor:default;

}
 
.updatesetup_featuredTitleHeader__2dH1T {
  color: var(--hsrcDarkBlue);
  font-size: 15px;
  font-weight: bold;
}

  /* Style the modal */
.updatesetup_modal__d-u5C {
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgba(0, 0, 0, 0.4); /* Semi-transparent black background */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  /* Modal Content */
  .updatesetup_modal_content__n2wFo {
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    border-radius: 5px;
    display: flex;
    align-items: center;
    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2);
    background-color: #fefefe;
  }
  
  .updatesetup_modal_text__T1IDd {
    margin-left: 14px;
    font-size: 24px;
  }
  
  /* Create the circle loader with pure CSS */
  .updatesetup_loader__d0RtV {
    width: 50px;
    height: 50px;
    border: 8px solid #ddd;
    border-top: 8px solid #2196f3;
    border-bottom: 8px solid #2196f3;
    border-radius: 50%;
    animation: updatesetup_spin__-pM28 2s linear infinite;
  }
  
  @keyframes updatesetup_spin__-pM28 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/components/UpdateSetup/updatesetup.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,UAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;;AAEf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;;AAEhB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;;AAEhB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;EAEE,oBAAoB;AACtB;IACI,eAAe,EAAE,kBAAkB;IACnC,UAAU,EAAE,eAAe;IAC3B,OAAO;IACP,MAAM;IACN,WAAW,EAAE,eAAe;IAC5B,YAAY,EAAE,gBAAgB;IAC9B,oCAAoC,EAAE,sCAAsC;IAC5E,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,kBAAkB;EAClB;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA,2CAA2C;EAC3C;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;IAC7B,gCAAgC;IAChC,kBAAkB;IAElB,qDAAkC;EACpC;;EAWA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF","sourcesContent":[".updateSetupContainer {\r\n  display: flex;\r\n  flex:  5;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  align-content: center;\r\n  justify-content: center;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  border-radius: 1rem;\r\n  padding: 2rem;\r\n\r\n}\r\n\r\n.featuredItem {\r\n  flex: 1;\r\n  margin: 0px 20px;\r\n  padding: 30px;\r\n  border-radius: 10px;\r\n  cursor:default;\r\n\r\n}\r\n.featuredDropDown {\r\n  flex: 1;\r\n  margin: 0px 20px;\r\n  padding: 30px;\r\n  border-radius: 10px;\r\n  cursor:default;\r\n\r\n}\r\n \r\n.featuredTitleHeader {\r\n  color: var(--hsrcDarkBlue);\r\n  font-size: 15px;\r\n  font-weight: bold;\r\n}\r\n\r\n  /* Style the modal */\r\n.modal {\r\n    position: fixed; /* Stay in place */\r\n    z-index: 1; /* Sit on top */\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%; /* Full width */\r\n    height: 100%; /* Full height */\r\n    background-color: rgba(0, 0, 0, 0.4); /* Semi-transparent black background */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  \r\n  /* Modal Content */\r\n  .modal_content {\r\n    margin: auto;\r\n    padding: 20px;\r\n    border: 1px solid #888;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2);\r\n    background-color: #fefefe;\r\n  }\r\n  \r\n  .modal_text {\r\n    margin-left: 14px;\r\n    font-size: 24px;\r\n  }\r\n  \r\n  /* Create the circle loader with pure CSS */\r\n  .loader {\r\n    width: 50px;\r\n    height: 50px;\r\n    border: 8px solid #ddd;\r\n    border-top: 8px solid #2196f3;\r\n    border-bottom: 8px solid #2196f3;\r\n    border-radius: 50%;\r\n    -webkit-animation: spin 2s linear infinite;\r\n    animation: spin 2s linear infinite;\r\n  }\r\n  \r\n  @-webkit-keyframes spin {\r\n    0% {\r\n      -webkit-transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      -webkit-transform: rotate(360deg);\r\n    }\r\n  }\r\n  \r\n  @keyframes spin {\r\n    0% {\r\n      transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"updateSetupContainer": `updatesetup_updateSetupContainer__oszGJ`,
	"featuredItem": `updatesetup_featuredItem__QyaVl`,
	"featuredDropDown": `updatesetup_featuredDropDown__m64Mu`,
	"featuredTitleHeader": `updatesetup_featuredTitleHeader__2dH1T`,
	"modal": `updatesetup_modal__d-u5C`,
	"modal_content": `updatesetup_modal_content__n2wFo`,
	"modal_text": `updatesetup_modal_text__T1IDd`,
	"loader": `updatesetup_loader__d0RtV`,
	"spin": `updatesetup_spin__-pM28`
};
export default ___CSS_LOADER_EXPORT___;
